var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96436 12.084H21.5208V21.578H2.96436V12.084Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7737 17.9499V16.5698H13.1703V17.9499H16.7737Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.778 16.5698V15.1898H10.3981V16.5698H11.778Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7737 15.1906V13.8105H13.1703V15.1906H16.7737Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1448 17.9746H11.7649V21.5784H13.1448V17.9746Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3858 17.9746H9.00586V21.5784H10.3858V17.9746Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23804 10.1409L20.5566 4.9645L21.2906 7.70403L1.97209 12.8804L1.23804 10.1409Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64723 8.69171C6.52476 8.621 6.30569 8.57617 6.27981 8.47958C6.03486 8.33816 5.8865 8.17085 5.80886 7.88108C5.73121 7.5913 5.77604 7.37223 5.91746 7.12728C5.96229 6.90822 6.22619 6.73398 6.51596 6.65633C6.80574 6.57869 7.02481 6.62351 7.26976 6.76494C7.63718 6.97707 8.30132 7.52381 8.86886 8.09643L12.9258 7.00939C13.2275 6.20383 13.4327 5.42415 13.7415 5.03085C13.7863 4.81178 14.0502 4.63754 14.2434 4.58578C14.5331 4.50813 14.7522 4.55296 14.9972 4.69438C15.4871 4.97723 15.6424 5.55678 15.3595 6.04668C15.2888 6.16915 15.2181 6.29163 15.1474 6.4141L17.5622 5.76706C17.6639 4.60101 17.1601 3.49366 16.0837 2.95386C14.7365 2.17604 12.8046 2.69368 12.0268 4.0409C11.744 4.5308 11.2559 5.80037 10.8904 7.14065C9.90364 6.16272 8.8462 5.30725 8.3563 5.02441C6.88661 4.17588 4.95476 4.69352 4.10623 6.16322C3.75267 6.77559 3.66995 7.62597 3.87701 8.39871C3.95465 8.68849 4.05818 9.07486 4.23242 9.33876L6.64723 8.69171Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit);
export default __webpack_public_path__ + "static/media/benefit.abadf81190f383d2237e0b185df28858.svg";
export { ForwardRef as ReactComponent };